import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {AbstractControl, ControlValueAccessor, UntypedFormControl, ValidationErrors, Validator} from '@angular/forms';

@Component({
  template: ''
})
export class BaseControlComponent implements ControlValueAccessor, Validator, OnChanges {
  @Input() public controlName: string;
  @Input() public disabled = false;
  @Input() public groupInstance: AbstractControl;

  public onChange;
  public onTouched;

  private value: any;

  public ngOnChanges(changes: SimpleChanges): void {
    const {disabled} = changes;

    if (disabled) {
      this.setDisableState(this.disabled);
    }
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {
    this.value = value;
  }

  public get isValid(): boolean {
    const control: AbstractControl = this.getControl();
    return control.valid;
  }

  public validate(control: UntypedFormControl): ValidationErrors | null {
    const validationErrors = {validationError: true};
    return this.isValid ? null : validationErrors;
  }

  protected getValue(): any {
    const control: AbstractControl = this.getControl();
    return control.value;
  }

  protected getControl(): AbstractControl {
    return this.groupInstance && this.groupInstance.get(this.controlName);
  }

  protected hasError(error: string) {
    return this.getControl().hasError(error);
  }

  private setDisableState(isDisabled: boolean): void {
    this.getControl()[isDisabled ? 'disable' : 'enable']();
  }
}
